import Layout from '@/layout'

const villageRouter = {
  path: '/',
  component: Layout,
  children: [
    {
      path: '/addressBook',
      name: 'addressBook',
      meta: {
        title: '登录',
      },
      component: () => import('@/views/addressBook/index.vue'),
    },
    {
      path: '/addressBook/addressBookList',
      name: 'addressBookList',
      meta: {
        title: '通讯录',
      },
      component: () => import('@/views/addressBook/list.vue'),
    },
    {
      path: '/addressBook/detail/:id',
      name: 'addressBookDetail',
      meta: {
        title: '个人详情',
      },
      component: () => import('@/views/addressBook/detail.vue'),
    },
  ],
}

export default villageRouter
